import { Action } from "../../store/types";
import * as actions from "./actions";
import { SuppInfoFormValues } from "./components/SuppInfoForm";

export interface Step5State {
  isSubmitting: boolean;
  submitError?: string;
  suppFormValues: SuppInfoFormValues;
}

const initState: Step5State = {
  isSubmitting: false,
  suppFormValues: {
    has_express_req: "false",
    has_payment_upfront: "true",
    num_additional_designs: "0",
    vat: "false",
  },
};

export default function(
  state = initState,
  { type, payload }: Action,
): Step5State {
  switch (type) {
    case actions.SET_SUBMITTING:
      return { ...state, isSubmitting: payload };
    case actions.SET_SUPP_FORM_VALUES:
      return { ...state, suppFormValues: payload };
    case actions.SET_SUBMIT_ERROR:
      return { ...state, submitError: payload };
    case actions.RESET:
      return initState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/routes/Step5/reducer.ts